import { createGlobalStyle } from 'styled-components'
import { fontFamily } from 'assets/themes/theme-default'

const ThemeFont = createGlobalStyle`
  body {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.normal.name},`} ${
  fontFamily.normal
};
  }
  h1 {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`} ${
  fontFamily.bold
};
  }
  h2 {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.semiBold.name},`} ${
  fontFamily.semiBold
};
  }
  h3 {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.medium.name},`} ${
  fontFamily.medium
};
  }
  h4 {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.semiBold.name},`} ${
  fontFamily.semiBold
};
  }
  h5 {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.semiBold.name},`} ${
  fontFamily.semiBold
};
  }
  .wafy-tooltip-information {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`} ${
  fontFamily.italic
};
}
`

export default ThemeFont
